// Featured Video Player

const VideoPlayer = ($) => {
	$("#video-player").on("click", function (event) {
		$(this).addClass("js-video-open");
		$(this).find(".featured-video__video")[0].src += "?&autoplay=1";
		event.preventDefault();
	});

	// for the second video player on the front page
	$("#video-player-top").on("click", function (event) {
		$(this).addClass("js-video-open");
		$(this).find(".featured-video__video")[0].src += "?&autoplay=1";
		event.preventDefault();
	});

	// for third video player on the front page
	$("#video-player-two").on("click", function (event) {
		$(this).addClass("js-video-open");
		$(this).find(".featured-video__video")[0].src += "?&autoplay=1";
		event.preventDefault();
	});

	/* for gallery video player inside the artist, program, and event single page —
	as well as the partnership template */
	$(".gallery-video-player").on("click", function (event) {
		$(this).addClass("js-video-open");
		$(this).find(".featured-video__video")[0].src += "?&autoplay=1";
		event.preventDefault();
	});
};

export default VideoPlayer;
